import { useMutation } from "@tanstack/react-query";
import { uploadInstance } from "../../axios";

const uploadBuildingsList = async (data: FormData) => {
  const companyId = data.get("companyId") as string;
  const countryName = data.get("countryName") as string;
  if (!companyId || !countryName) throw new Error("Data not provided");
  const params = new URLSearchParams({ companyId, countryName });
  return uploadInstance
    .post("buildings/upload", data, { params })
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const useUploadBuildingsList = () => {
  return useMutation({
    mutationFn: (data: FormData) => uploadBuildingsList(data),
    mutationKey: ["buildings"],
  });
};

export default useUploadBuildingsList;
